import { assocIf } from '@btime/helpers'
import React from 'react'

import { TO_GROUP, TO_USER } from './_constants/assignConstants'
import { useSaveServiceOrder } from './_requests/saveServiceOrder'
import { useServiceOrder } from './_load/ServiceOrderLoader'
import AssignContent from './assign/AssignContent'
import AssignTypePicker from './assign/AssignTypePicker'
import Form from '../../../packages/kiti/components/form/form/Form'
import Separator from '../../../components/helpers/Separator'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import { useNavigationWithModalCloser } from '../../../utils/contexts/NavigationContext'
import { useForm, useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import { useLoggedUser } from '@btime/react-session'
import Button from '../../../packages/kiti/components/actions/Button'
import { useOpenExecuteServiceOrderModal } from '../../../utils/routes/modals/modalsActions'

const ModalFooter = ({ loading, ...props }) => {
  const navigate = useNavigationWithModalCloser()
  const openExecutionModal = useOpenExecuteServiceOrderModal()
  const form = useForm()
  const { handleSubmit } = useFormState()
  const loggedUser = useLoggedUser()

  const selectedUser = form.userOrGroup?.__typename === 'User' ? form.userOrGroup : {}
  const isForSelf = loggedUser.id === selectedUser?.id && !props.loading
  const onSuccess = record => openExecutionModal(record)

  return (
    <SubmitBar loading={loading} {...props}>
      {isForSelf && (
        <Button loading={loading} transparent color="dark3" onClick={() => handleSubmit({ onSuccess })}>
          {'Salvar e executar'}
        </Button>
      )}
    </SubmitBar>
  )
}

const EditUserForm = () => {
  const serviceOrder = useServiceOrder()
  const [onSubmit, { loading, error }] = useSaveServiceOrder()
  const data = {
    ...serviceOrder,
    ...assocIf(!!serviceOrder?.user, 'userOrGroup', serviceOrder?.user),
    ...assocIf(!!serviceOrder?.group, 'userOrGroup', serviceOrder?.group),
    ...assocIf(!!serviceOrder?.groups?.length, 'userOrGroup', serviceOrder?.groups),
    assign: !!serviceOrder?.group?.id || serviceOrder?.groups?.length ? TO_GROUP : TO_USER
  }

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={data}>
      <AssignTypePicker />
      <Separator weight={4} />
      <AssignContent />
      <Separator weight={6} />
      <ModalFooter loading={loading} error={error} />
    </Form>
  )
}

export default EditUserForm
